import React, { useState } from "react";
import { toast } from "react-toastify";
import { postApi } from "../../../Services/apiService";
import "../../../Auth.css";

const PasswordField = ({
  id,
  label,
  value,
  placeholder,
  error,
  visible,
  onChange,
  onToggleVisibility,
}) => (
  <div className="col-md-12 form-group">
    <label htmlFor={id} className="required-label">
      {label}
    </label>
    <div className="password-wrapper">
      <input
        className="form-control"
        type={visible ? "text" : "password"}
        name={id}
        id={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required
      />
      <button
        type="button"
        className="eye-icon"
        onClick={onToggleVisibility}
        aria-label={visible ? `Hide ${label}` : `Show ${label}`}
      >
        <img
          src={
            visible
              ? window.getPublicUrl("/assets/images/Eye.svg")
              : window.getPublicUrl("/assets/images/Eye-closed.svg")
          }
          alt=""
        />
      </button>
    </div>
    {error && <div className="error">{error}</div>}
  </div>
);

const ChangePassword = () => {
  const [form, setForm] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [errors, setErrors] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [loading, setLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => {
      const updatedForm = {
        ...prev,
        [name]: value,
      };
      let confirmError = "";

      //Real time check for the confirm password
      if (
        name === "confirmNewPassword" ||
        (name === "newPassword" && updatedForm.confirmNewPassword)
      ) {
        if (updatedForm.newPassword !== updatedForm.confirmNewPassword) {
          confirmError = "Passwords do not match";
        }
      }

      setErrors((prev) => ({
        ...prev,
        [name]: "",
        confirmNewPassword: confirmError,
      }));

      return updatedForm;
    });

    // setForm((prev) => ({ ...prev, [name]: value }));
    // setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  // Toggle password visibility
  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  // Handle form submit
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    let newErrors = {};

    if (!form.currentPassword.trim()) {
      newErrors.currentPassword = "Current password is required";
    } else if (form.currentPassword.length < 6) {
      newErrors.currentPassword =
        "Current password must be at least 6 characters";
    }

    if (!form.newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } else if (form.newPassword.length < 6) {
      newErrors.newPassword = "New password must be at least 6 characters";
    }

    if (form.newPassword !== form.confirmNewPassword) {
      newErrors.confirmNewPassword = "Passwords do not match";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Password updated successfully", form);
      const payload = {
        old_password: form.currentPassword,
        new_password: form.newPassword,
        confirm_new_password: form.confirmNewPassword,
      };
      // Integrate API
      try {
        // Api call
        setLoading(true);
        const response = await postApi("/auth/change-password", payload);
        console.log(response);
        toast.success("Password updated successfully");
        setForm({
          currentPassword: "",
          newPassword: "",
          confirmNewPassword: "",
        });

        setErrors({});
      } catch (error) {
        console.error("Error changing password:", error);
        toast.error(
          error?.response?.data?.message || "Failed to update password"
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="change-password right-with-header" aria-label="Change password">
      <div className="main-rightside">
        <form className="profile-form" onSubmit={handleFormSubmit}>
          <div className="row">
            <PasswordField
              id="currentPassword"
              label="Current Password"
              placeholder="Current Password"
              value={form.currentPassword}
              error={errors.currentPassword}
              visible={showPassword.current}
              onChange={handleChange}
              onToggleVisibility={() => togglePasswordVisibility("current")}
            />

            <PasswordField
              id="newPassword"
              label="New Password"
              placeholder="New Password"
              value={form.newPassword}
              error={errors.newPassword}
              visible={showPassword.new}
              onChange={handleChange}
              onToggleVisibility={() => togglePasswordVisibility("new")}
            />

            <PasswordField
              id="confirmNewPassword"
              label="Confirm New Password"
              placeholder="Confirm New Password"
              value={form.confirmNewPassword}
              error={errors.confirmNewPassword}
              visible={showPassword.confirm}
              onChange={handleChange}
              onToggleVisibility={() => togglePasswordVisibility("confirm")}
            />

            <div className="col-md-12 float-inline-end">
              <button
                type="submit"
                className="btn btn-upload w-100"
                disabled={loading}
              >
                {loading ? "Updating..." : "Update Password"}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
